import Modal from 'components/commons/modal/Modal2';
import React from 'react';
import { AssetType } from 'config/consts';
import { AssetTypeKey, assetTypeKeyToString } from '../utils/assetType';

export const DailyReportWhatIsIncludeAsstsModal = ({
  hideModal,
  isShowModal,
  assetTypeKey,
}: {
  isShowModal: boolean;
  hideModal: () => void;
  assetTypeKey: AssetTypeKey;
}): React.ReactElement => {
  const title = assetTypeKeyToString(assetTypeKey);

  return (
    <>
      <Modal {...{ isShow: isShowModal, close: hideModal }}>
        <div className="ui-border-b flex flex-col pt-4">
          <div className="flex flex-row pb-4 px-4">
            <div className="text-bluegray-700 font-bold text-base">
              {assetTypeKey === AssetType.国内現物
                ? 'この資産について'
                : `${title}に含まれる資産`}
            </div>
            <div
              className="icon-close text-bluegray-400 ml-auto text-lg cursor-pointer"
              onClick={hideModal}></div>
          </div>
          <div className="px-4 pb-2 text-sm text-bluegray-700">
            <div className="leading-6">
              {(() => {
                switch (assetTypeKey) {
                  case AssetType['国内現物']:
                    return (
                      <>
                        <div>・直接手入力した資産</div>
                        <div>・マネーツリーで内訳が不明な資産</div>
                      </>
                    );
                  case AssetType['預金_MRF']:
                    return (
                      <>
                        <div>・預り金</div>
                        <div>・MRF</div>
                        <div>・直接入力した預金・MRF</div>
                      </>
                    );
                  case AssetType['その他']:
                    return (
                      <>
                        <div>・Moneytreeに連携した国内株式を除く資産</div>
                        <div>・直接入力で「その他」に分類した資産</div>
                        <div>
                          ・一部のアクティブファンド等、分類ができない投資信託
                        </div>
                      </>
                    );
                }
              })()}
            </div>
          </div>
          <button
            onClick={hideModal}
            className="bg-white p-4 px-8 text-bluegray-500 text-sm flex justify-center items-center">
            閉じる
          </button>
        </div>
      </Modal>
    </>
  );
};
